import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { useLang } from "@/contexts/LanguageContext";

export function Footer() {
  const { t } = useLang();
  return (
    <footer className="relative border-t border-white/8 bg-arven-noir mt-10" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-6 md:px-10 lg:px-14 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-4">
            <Logo variant="tagline" />
            <p className="mt-6 text-sm leading-relaxed text-arven-offwhite/70 max-w-xs">
              {t.footer.tagline}
            </p>
          </div>

          <div className="md:col-span-2">
            <h4 className="label-eyebrow mb-5">{t.footer.cols.pages}</h4>
            <ul className="space-y-3 text-sm text-arven-offwhite/80">
              <li><Link to="/collections" className="hover:text-arven-gold transition-colors">{t.nav.collections}</Link></li>
              <li><Link to="/materiaux" className="hover:text-arven-gold transition-colors">{t.nav.materials}</Link></li>
              <li><Link to="/projets" className="hover:text-arven-gold transition-colors">{t.nav.projects}</Link></li>
              <li><Link to="/savoir-faire" className="hover:text-arven-gold transition-colors">{t.nav.savoir}</Link></li>
              <li><Link to="/professionnels" className="hover:text-arven-gold transition-colors">{t.nav.pros}</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="label-eyebrow mb-5">{t.footer.cols.contact}</h4>
            <ul className="space-y-3 text-sm text-arven-offwhite/80">
              <li>
                <a href="mailto:contact@arven-cuisines.com" className="hover:text-arven-gold transition-colors">
                  contact@arven-cuisines.com
                </a>
              </li>
              <li>
                <a href="tel:+41215394309" className="hover:text-arven-gold transition-colors">
                  +41 21 539 43 09
                </a>
              </li>
              <li className="text-arven-offwhite/70">
                Rue Jean-André Venel 4<br />
                1400 Yverdon-les-Bains<br />
                Suisse
              </li>
            </ul>
            <Link to="/rendez-vous" className="btn-text-gold mt-5">
              {t.nav.cta}
            </Link>
          </div>

          <div className="md:col-span-3">
            <h4 className="label-eyebrow mb-5">{t.footer.cols.legal}</h4>
            <ul className="space-y-3 text-sm text-arven-offwhite/60">
              <li><Link to="/mentions-legales" className="hover:text-arven-gold transition-colors">{t.footer.legal_items[0]}</Link></li>
              <li><Link to="/mentions-legales#confidentialite" className="hover:text-arven-gold transition-colors">{t.footer.legal_items[1]}</Link></li>
              <li><Link to="/mentions-legales#cookies" className="hover:text-arven-gold transition-colors">{t.footer.legal_items[2]}</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-xs text-arven-offwhite/45 tracking-wider">
            © {new Date().getFullYear()} {t.footer.rights}
          </p>
          <p className="text-[10px] tracking-[0.32em] uppercase text-arven-offwhite/35">
            {t.footer.signature}
          </p>
        </div>
      </div>
    </footer>
  );
}
